export { default } from "./chart4";


// WEBPACK FOOTER //
// ./src/components/chart4/index.js